import { isValidUKCountry, UKCountry } from './types';

const COOKIE_NAME = 'platgen_uk_country';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

export function getCountryCookie(): UKCountry | null {
  for (const cookie of document.cookie.split(';')) {
    const eqIndex = cookie.indexOf('=');
    if (eqIndex === -1) {
      continue;
    }
    const key = cookie.slice(0, eqIndex).trim();
    const value = cookie.slice(eqIndex + 1).trim();
    if (key === COOKIE_NAME) {
      const decoded = decodeURIComponent(value);
      return isValidUKCountry(decoded) ? decoded : null;
    }
  }
  return null;
}

export function setCountryCookie(country: UKCountry): void {
  const secure = process.env.NODE_ENV === 'production' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
    country
  )}; Max-Age=${COOKIE_MAX_AGE}; SameSite=Strict; Path=/${secure}`;
}

export function clearCountryCookie(): void {
  document.cookie = `${COOKIE_NAME}=; Max-Age=0; SameSite=Strict; Path=/`;
}
